module.exports = "/_next/static/images/top-projects-8b05333d482270feedf4a422f27052f1.jpg";